<div class="modal-header">
  <h4 class="modal-title">Data Generated Successfully</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  <!-- Status Summary -->
  <div class="status-summary mb-4">
    <div class="mt-3 text-center success-message">
      <div class="output-container">
        Total Script Execution Time: {{ executionTime }} seconds
      </div>
      
      <!-- DMSH Status Section -->
      <div *ngIf="hasDmshData" class="dmsh-section mt-3">
        <h5 class="mb-3">DMSH Status: {{ dmshStatus }}</h5>
        
        <div class="dmsh-summary mb-3">
          <span class="badge bg-success me-2">{{ dmshSuccessfulTables }} Successful Tables</span>
          <span class="badge bg-danger" *ngIf="dmshFailedTables > 0">{{ dmshFailedTables }} Failed Tables</span>
        </div>
        
        <!-- Successful DMSH Messages -->
        <div class="dmsh-successful mb-3" *ngIf="dmshResponses.length > 0">
          <h6 class="fw-bold">Successful Operations:</h6>
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead class="table-light">
                <tr>
                  <th>Table Name</th>
                  <th>Message ID</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let response of dmshResponses">
                  <td>{{ response.table }}</td>
                  <td><small class="text-muted">{{ response.message_id }}</small></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <!-- Failed DMSH Messages -->
        <div class="dmsh-errors" *ngIf="dmshErrors.length > 0">
          <h6 class="fw-bold text-danger">Failed Operations:</h6>
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead class="table-light">
                <tr>
                  <th>Table Name</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of dmshErrors">
                  <td>{{ error.table }}</td>
                  <td class="text-danger"><small>{{ error.error }}</small></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Download Section -->
  <div class="download-section">
    <div class="alert alert-info d-flex align-items-center" *ngIf="isDownloadAvailable">
      <div class="download-info">
        <!-- <div class="download-ready-icon me-3">
          <i class="bi bi-file-earmark-arrow-down"></i>
        </div> -->
        <div>
          <h5 class="mb-1">Data file(s) are ready for download</h5>
          <div class="file-size" *ngIf="downloadFileSize">
            File Size: {{ (downloadFileSize / 1024).toFixed(2) }} KB
          </div>
        </div>
      </div>
    </div>
    
    <div class="alert alert-warning d-flex align-items-center" *ngIf="!isDownloadAvailable">
      <div class="download-info">
        <!-- <div class="warning-icon me-3">
          <i class="bi bi-exclamation-triangle"></i>
        </div> -->
        <div>
          <!-- <h5 class="mb-0">No data files available</h5> -->
          <p class="mb-0">There are no data file(s) available for download from this execution.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="onCancel()">Close</button>
  <button class="btn btn-success download-btn" *ngIf="isDownloadAvailable" [disabled]="isDownloading" (click)="downloadFile()">
    <i class="bi bi-download me-1"></i>
    <span *ngIf="!isDownloading">Download</span>
    <span *ngIf="isDownloading">
      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      Downloading...
    </span>
  </button>
  <button class="btn btn-primary" (click)="onSaveAndReturn()">Save & Return to Home</button>
</div>